"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectFilter = _interopRequireDefault(require("./objectFilter"));

/**
 * @param {Object} object - object to run filters on
 * @param {String|String[]} filters - property name or names to include
 */
var pick = function pick(object) {
  for (var _len = arguments.length, filters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filters[_key - 1] = arguments[_key];
  }

  return _objectFilter.default.apply(void 0, [object, true].concat(filters));
};

var _default = pick;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/underscore/pick.js
// module id = 701
// module chunks = 209 210 211 212